import SelectInput from "@components/common/SelectInput";
import ActivationTypeComponent from "@components/forms/ActivationTypeComponent";
import {
	fetchAccountNumbersCountriesData,
	fetchAccountNumbersSelectData,
	fetchSubscriptionPlans,
} from "@services/accountMangement/accountNumbersService";
import { setAllAccountNumbersList } from "@store/modules/accountManagement/accountNumbersSlice";
import { ToggleSwitch } from "flowbite-react";
import { useEffect, useState } from "react";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { customThemeToggleSwitch } from "styles/customTheme";
// import { countries } from "@utils/countries";

import SelectMultipleInputs from "@components/common/SelectMultipleInputs";
import BlockRelationSelectComponent from "@components/forms/BlockRelationSelectComponent";

const ActivationBusinessUnitClientConfigSection = ({
	token,
	formData,
	setFormData,
	errors,
	setErrors,
	selectedRowData,
}) => {
	const dispatch = useDispatch();
	const navigate = useNavigate();
	const [loading, setLoading] = useState(false);
	const [loadingsubscription, setLoadingsubscription] = useState(false);
	const [loadingcountry, setLoadingcountry] = useState(false);

	const [subscriptionPlans, setSubscriptionPlans] = useState([]);
	const [showAddressForm, setShowAddressForm] = useState(false);
	const [countries, setCountries] = useState([]);

	const [showStatus, setShowStatus] = useState("");

	const allAccountNumbersList = useSelector(
		(state) => state.modules.accountManagement.accountNumbers.list || [],
	);

	useEffect(() => {
		if (formData.type && formData.countryName) {
			fetchAccountNumbers();
			// const shouldFetchAccountNumbers =
			//   formData.type !== "LAND" ||
			//   (formData.type === "LAND" && formData.countryName);

			// if (shouldFetchAccountNumbers) {

			// }
		}
	}, [formData.type, formData.countryName]);

	useEffect(() => {
		setShowStatus(formData.status === 1);
	}, [formData.status]);

	const handleStatusToggle = (checked) => {
		setShowStatus(checked);
		setFormData((prev) => ({
			...prev,
			status: checked ? 1 : 0,
		}));
	};

	useEffect(() => {
		if (formData.isPool !== undefined && formData.isPool !== null && formData.type) {
			setLoadingsubscription(true);
			const type = formData.type === "MOBILE" ? "mobile" : "fixe";

			fetchSubscriptionPlansList(type, formData.isPool);
		}
	}, [formData.isPool, formData.type]);

	const fetchAccountNumbers = async () => {
		setLoading(true);
		const searchTerms = {
			is_mobile: formData.type,
			// is_pool: formData.isPool,
			// subscription_plan: formData.subscription, // Subscription Plan
		};

		if (formData.countryName) {
			searchTerms.countryName = formData.countryName;
		}
		try {
			const datalist = await fetchAccountNumbersSelectData(
				token,
				dispatch,
				navigate,
				searchTerms,
				false,
			);
			const data = datalist.data;
			dispatch(setAllAccountNumbersList({ data }));
		} catch (error) {
			console.error("Failed to fetch account numbers:", error);
		} finally {
			setLoading(false);
		}
	};

	const handleOptionChange = async (id, value, name) => {
		if (id == "accountNumber") {
			const selectedAccount = await allAccountNumbersList.find((account) => account.id === value);
			await setFormData((prev) => ({
				...prev,
				account_number_id: value,
				account_number: name,
				isPool: selectedAccount?.is_pool ?? null,
			}));
		} else if (id == "subscriptionPlan") {
			setFormData((prev) => ({
				...prev,
				subscription: value,
				subscription_name: name,
			}));
		}
	};

	const handleTypeChange = async (type) => {
		await setLoadingcountry(true);
		setFormData((prev) => ({
			...prev,
			type,
			account_number_id: null,
			account_number: "",
			subscription: [],
			subscription_name: "",
			countryName: "",
			countryCode: "",
			isPool: null,
			is_block_related: null,
		}));
		/************Call api countries**************** */
		try {
			setCountries([]);

			const data = await fetchAccountNumbersCountriesData(token, dispatch, navigate, false);

			const options = data.map((unit, key) => ({
				id: unit,
				name: unit,
			}));

			await setCountries(options);
			await setLoadingcountry(false);
		} catch (error) {
			console.error("Error fetching countries:", error);
			setLoadingcountry(false);
		} finally {
			setLoadingcountry(false);
		}
	};
	const handleBlockChange = (is_block_related) => {
		setFormData((prev) => ({ ...prev, is_block_related }));
	};

	// const countryOptionsByName = useMemo(() => {

	//   return countries.map((unit) => ({
	//     id: unit,
	//     name: unit,
	//   }));
	// }, []);

	const fetchSubscriptionPlansList = async (selectedType, number) => {
		const params = {
			is_pool: formData.isPool,
			is_mobile: formData.type,
		};
		try {
			const datalist = await fetchSubscriptionPlans(token, dispatch, navigate, params, false);

			setSubscriptionPlans(datalist);
		} catch (error) {
			console.error("Failed to fetch account numbers:", error);
		} finally {
			setLoadingsubscription(false);
		}
	};

	const handleSubscriptionChange = (id, selectedIds) => {
		setFormData((prev) => ({
			...prev,
			subscription: selectedIds,
		}));
	};

	const handleIsProrataChange = (id, value) => {
		setFormData((prev) => ({ ...prev, is_prorata: value }));
	};

	// const handleStatusToggle = async () => {
	//   const newStatus = formData.status === 1 ? 0 : 1; // Toggle between active (1) and inactive (0)
	//   setFormData((prev) => ({ ...prev, status: newStatus }));
	// };

	useEffect(() => {
		const initializeForm = async () => {
			if (selectedRowData && selectedRowData.id) {
				setCountries([]);

				try {
					const data = await fetchAccountNumbersCountriesData(token, dispatch, navigate, false);

					const options = data.map((unit, key) => ({
						id: unit,
						name: unit,
					}));

					setCountries(options);

					const countryName = selectedRowData?.account_number?.country || "";

					// Find the matching country object by name
					const matchedCountry = options.find((country) => country.name === countryName);
					const countryCode = matchedCountry ? matchedCountry.id : "";
					setFormData((prev) => ({
						...prev,
						type: selectedRowData.type || "",
						account_number_id: selectedRowData.account_number?.id || "",
						account_number: selectedRowData.account_number?.number || "",
						isPool: selectedRowData.account_number?.is_pool ?? null,
						status: selectedRowData.status ?? 0,
						is_block_related: selectedRowData.block_product === 1 ? "yes" : "no",
						countryName: countryName,
						countryCode: countryCode,
						fixed_address: selectedRowData.fixed_address || "",
						subscription: selectedRowData.vessel_subscriptions?.map((s) => s.id) || [],
						is_prorata: selectedRowData.is_prorata ?? null,
					}));
				} catch (error) {
					console.error("Failed to fetch countries", error);
				}
			}
		};

		initializeForm();
	}, [selectedRowData]);

	return (
		<>
			<>
				{/* <IsPoolComponent
            formData={formData}
            setFormData={setFormData}
            // errors={errors}
            FieldsName={["Pool", "Standard"]}
            label="Type of role * :"
            //initialiaseValuse={{"subscription": []} {"account_number":0} }
          />
          
          <div className="mt-4 text-red-500 text-sm">
            {errors?.isPool && <p>{errors?.isPool}</p>}
          </div>
          
          */}
				<ActivationTypeComponent
					formData={formData}
					setFormData={handleTypeChange}
					errors={errors}
				/>
				<div className="mt-4 text-red-500 text-sm">{errors.type && <p>{errors.type}</p>}</div>
				<div className="mt-14">
					{loadingcountry ? (
						<Skeleton height={16} borderRadius={6} baseColor="#727DA3" highlightColor="#1b204c" />
					) : (
						<SelectInput
							id="countryName"
							dataTestId="countryname-select"
							placeholder="Country Name"
							label={"Country Name * :"}
							value={formData.countryCode}
							onChange={(id, selectedValue, selectedText) => {
								setFormData({
									...formData,
									countryCode: selectedValue,
									countryName: selectedText,
								});
								setErrors((prevErrors) => ({
									...prevErrors,
									countryCode: "",
									countryName: "",
								}));
							}}
							options={countries}
							className={`block h-9 w-9 rounded-lg border border-gray-600 bg-gray-700 py-3 text-gray-400 placeholder-gray-400 focus:border-primary-500 focus:ring-primary-500 ${
								errors.countryName ? "border-red-500" : ""
							}`}
							required
							disabled={!formData.type}
						/>
					)}
					{/* // formData.isPool === null ||
                  // formData.subscription === undefined ||
                  // formData.subscription === null ||
                  // !formData.subscription.length */}

					<div className="mt-4 text-red-500 text-sm">
						{errors.countryName && <p>{errors.countryName}</p>}
					</div>
				</div>

				<div className="mt-14">
					{loading ? (
						<Skeleton height={16} borderRadius={6} baseColor="#727DA3" highlightColor="#1b204c" />
					) : (
						<SelectInput
							id="accountNumber"
							dataTestId="accountNumber-select"
							placeholder="Account Number"
							label={`Account Number * : ${
								formData.countryName === undefined ||
								formData.countryName === null ||
								formData.countryName === "" ||
								formData.countryName === "N/A"
									? "Select 'Country' first"
									: ""
							}`}
							value={formData.account_number_id}
							onChange={handleOptionChange}
							options={allAccountNumbersList}
							displayField="number"
							disabled={!formData.type || !formData.countryName || formData.countryName === "N/A"}
						/>
					)}
					{/* // formData.isPool === null ||
                  // formData.subscription === undefined ||
                  // formData.subscription === null ||
                  // !formData.subscription.length */}
					<div className="mt-4 text-red-500 text-sm">
						{errors.account_number_id && <p>{errors.account_number_id}</p>}
					</div>
				</div>
				{/* If is_pool = 1 for the account number selected */}
				{formData.isPool === 1 && (
					<>
						<BlockRelationSelectComponent
							formData={formData}
							setFormData={handleBlockChange}
							errors={errors}
						/>
						<div className="mt-4 text-red-500 text-sm">
							{errors.is_block_related && <p>{errors.is_block_related}</p>}
						</div>
					</>
				)}

				<div className="mt-4">
					{loadingsubscription ? (
						<Skeleton height={16} borderRadius={6} baseColor="#727DA3" highlightColor="#1b204c" />
					) : (
						<SelectMultipleInputs
							id="subscriptionPlan"
							placeholder="Subscription Plan"
							label={`Subscription Plan * : ${
								!formData.type || formData.isPool === undefined || formData.isPool === null
									? "Select 'Type of role' first"
									: ""
							}`}
							value={Array.isArray(formData.subscription) ? formData.subscription : []}
							onChange={handleSubscriptionChange}
							options={subscriptionPlans}
							displayField="name"
							disabled={
								!formData.type ||
								formData.isPool === undefined ||
								formData.isPool === null ||
								loadingsubscription
							}
						/>
					)}
					<div className="mt-4 text-red-500 text-sm">
						{errors.vessel_subscription_ids && <p>{errors.vessel_subscription_ids}</p>}
					</div>

					<div className="mt-4">
						<SelectInput
							id="is_prorata"
							label="Prorata *"
							placeholder="Select Option"
							value={formData.is_prorata}
							onChange={handleIsProrataChange}
							options={[
								{ id: 1, name: "Yes" },
								{ id: 0, name: "No" },
							]}
							displayField="name"
							disabled={
								!formData.type ||
								formData.isPool === undefined ||
								formData.isPool === null ||
								loadingsubscription
							}
						/>
						<div className="mt-4 text-red-500 text-sm">
							{errors.is_prorata && <p>{errors.is_prorata}</p>}
						</div>
					</div>

					{selectedRowData && (
						<div className="flex items-center gap-3 border-gray-600 py-4">
							<ToggleSwitch
								checked={showStatus}
								onChange={handleStatusToggle}
								value={formData.status}
								color="green"
								sizing="sm"
								theme={customThemeToggleSwitch}
							/>
							<label className="font-medium text-gray-400 text-xs">
								{formData?.status === 0
									? `Enable Configuration Status`
									: `Disable Configuration Status`}
							</label>
						</div>
					)}
				</div>
			</>
		</>
	);
};

export default ActivationBusinessUnitClientConfigSection;
